import { render } from "./OapMediaCarouselControls.vue?vue&type=template&id=8c1e2ea4"
import script from "./OapMediaCarouselControls.vue?vue&type=script&lang=js"
export * from "./OapMediaCarouselControls.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__